module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.orderDetail.servCataId == '3010130') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "矫治方案"
    }
  }), _vm._v(" "), (['20', '40', '50'].includes(_vm.orderDetail.orderStatus)) ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '19',
        objectTag: _vm.orderDetail.servOrderId
      },
      "before-upload": _vm.beforeUpload,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false
    }
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40') ? _c('div', {
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designCorrectPlan), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPPT(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 15, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]) : _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item, 15, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })]) : _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item), index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designCorrectPlan.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("ppt格式文件")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "30px",
      "color": "#00A5D5"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.downTemplate()
      }
    }
  }, [_vm._v("下载模板")])])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignData == '1' && _vm.orderDetail.servCataId != '3010130') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "设计文件"
    }
  }), _vm._v(" "), (['20', '40', '50'].includes(_vm.orderDetail.orderStatus)) ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '11',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false,
      "on-exceed": _vm.handleExceed
    }
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40') ? _c('div', {
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designDataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [_c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.to3dModel()
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 11, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designDataList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(0)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignReport == '1') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [(_vm.plateShow) ? _c('base-tag', {
    attrs: {
      "label": "手术报告"
    }
  }) : _c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "种植导板手术规划报告(PDF格式)"
    }
  }), _vm._v(" "), (['20', '40'].includes(_vm.orderDetail.orderStatus)) ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '12',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false,
      "on-exceed": _vm.handleExceed
    }
  }, [(['20', '40'].includes(_vm.orderDetail.orderStatus)) ? _c('div', {
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designReportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(_vm.isJson) ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPdf(_vm.orderDetail.designReport, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPdf(_vm.orderDetail.designReport, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 12, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item), index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designReportList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(1)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignGuide == '1') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [(_vm.plateShow) ? _c('base-tag', {
    attrs: {
      "label": "钻针指南文件"
    }
  }) : _c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "器械钻针使用流程及注意事项(PDF格式)"
    }
  }), _vm._v(" "), (['20', '40'].includes(_vm.orderDetail.orderStatus)) ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '13',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false,
      "on-exceed": _vm.handleExceed
    }
  }, [(['20', '40'].includes(_vm.orderDetail.orderStatus)) ? _c('div', {
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designGuideList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(_vm.isJson) ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPdf(_vm.orderDetail.designGuide, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPdf(_vm.orderDetail.designGuide, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 13, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })]) : _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item), index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designGuideList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(2)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "模拟视频"
    }
  }), _vm._v(" "), (_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40' || _vm.orderDetail.orderStatus == '50') ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '20',
        objectTag: _vm.orderDetail.servOrderId
      },
      "before-upload": _vm.beforeUploadVideo,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false
    }
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderDetail.servCataId == '3010130'),
      expression: "orderDetail.servCataId=='3010130'"
    }],
    ref: "uploadCnc",
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designAnalogVideo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(_vm.isJson) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.toView(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('label', {
      on: {
        "click": function($event) {
          return _vm.toView(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 16, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })]) : _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item), index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designAnalogVideo.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(3)]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "CNC制造文件"
    }
  }), _vm._v(" "), (['20', '40', '50'].includes(_vm.orderDetail.orderStatus)) ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '14',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false,
      "on-exceed": _vm.handleExceed
    }
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40') ? _c('div', {
    ref: "uploadCnc",
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_c('div', {
    staticClass: "pane-download"
  }, [_c('div', {
    staticClass: "no-file"
  }, [_c('span', [_vm._v("请上传stl制造文件，压缩为一个文档上传。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "50px",
      "color": "#00A5D5"
    }
  }, [_vm._v("\n              总计:\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bracesCount),
      expression: "bracesCount"
    }],
    staticStyle: {
      "border-bottom": "1px solid #00A5D5",
      "background": "#ECECEC",
      "width": "50px",
      "text-align": "center"
    },
    domProps: {
      "value": (_vm.bracesCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bracesCount = $event.target.value
      }
    }
  }), _vm._v("副\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designMakeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(item.name.substring(item.name.lastIndexOf('.') + 1) == 'stl') ? _c('a', {
      on: {
        "click": _vm.to3dModel
      }
    }, [_vm._v(_vm._s(item.name))]) : (_vm.isJson) ? _c('label', [_vm._v(_vm._s(item.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 14, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })]) : _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item), index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designMakeList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(4)]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId !== '3010130') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [(_vm.plateShow) ? _c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "制造文件"
    }
  }) : _c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "种植导板制造文件"
    }
  }), _vm._v(" "), (['20', '40', '50'].includes(_vm.orderDetail.orderStatus)) ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '14',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false,
      "on-exceed": _vm.handleExceed
    }
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40') ? _c('div', {
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designMakeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [_c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(item.name.substring(item.name.lastIndexOf('.') + 1) == 'stl') ? _c('a', {
      on: {
        "click": _vm.to3dModel
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('label', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 14, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designMakeList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(5)]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_c('base-tag', {
    staticClass: "upload-tag",
    attrs: {
      "label": "设计方案源文件"
    }
  }), _vm._v(" "), (_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40' || _vm.orderDetail.orderStatus == '50') ? _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '11',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "show-file-list": false,
      "on-exceed": _vm.handleExceed
    }
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40') ? _c('div', {
    staticClass: "upload-file-dragger"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("立即上传")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-box"
  }, [_vm._l((_vm.designDataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(item.name.substring(item.name.lastIndexOf('.') + 1) != 'stl') ? _c('a', {
      staticStyle: {
        "color": "#606266"
      },
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.name))]) : (_vm.isJson) ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.to3dModel()
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item.url, 11, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]) : _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.handleRemove(item, 11, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name, index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })]) : _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item), index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])])
  }), _vm._v(" "), (_vm.designDataList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(6)]) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), ((_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '40')) ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "留言信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "temp",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 20
      },
      "placeholder": "可选填，填写提示下单方注意的相关信息"
    },
    model: {
      value: (_vm.designRemark),
      callback: function($$v) {
        _vm.designRemark = $$v
      },
      expression: "designRemark"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderStatus == '20' || _vm.orderStatus == '40') ? _c('div', {
    staticClass: "design-confirm-btn"
  }, [_c('y-button', {
    attrs: {
      "text": "立即提交",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickSubmit
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("mp4格式文件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")]), _vm._v(" "), _c('span', {
    staticClass: "upload-prompt"
  }, [_vm._v("请回传修复体切削文件，边缘线文件（螺丝孔文件）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")]), _vm._v(" "), _c('span', {
    staticClass: "upload-prompt"
  }, [_vm._v("压缩包/3sz格式文件")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62896207","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/detailUpload.vue
// module id = 664
// module chunks = 0